import { render } from "./Funnel.vue?vue&type=template&id=2677e344&scoped=true"
import script from "./Funnel.vue?vue&type=script&setup=true&lang=js"
export * from "./Funnel.vue?vue&type=script&setup=true&lang=js"

import "./Funnel.vue?vue&type=style&index=0&id=2677e344&scoped=true&lang=css"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2677e344"],['__file',"src/icons/Funnel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2677e344"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2677e344', __exports__)) {
    api.reload('2677e344', __exports__)
  }
  
  module.hot.accept("./Funnel.vue?vue&type=template&id=2677e344&scoped=true", () => {
    api.rerender('2677e344', render)
  })

}


export default __exports__